import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';

export default class VirtualAccountInstructions extends Component{
  constructor(props){
    super(props);
    this.state={
    }
  }

  render(){
    return(
      <div className="instruction-content">
        <div className="title-instruction">
            <p><b>Instructions</b></p>
        </div>
        <div className="instruction-topup">    
          <ul>
            <li>
              Will be provided on the next screen
            </li>
          </ul>
        </div>
      </div>
    )
  }
}